import { useState, useCallback } from 'react'

export function useForceUpdate () {
  const [tick, setTick] = useState(0)
  return [
    tick,
    useCallback(() => {
      setTick(tick => tick + 1)
    }, [])
  ]
}
